import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FiX } from 'react-icons/fi';

/**
 * Crisis banner pinned above the navbar. Dismissible, but deliberately not
 * persisted to storage — someone arriving in crisis on a later visit should see
 * it again.
 */
export default function AlertBar() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="mm-alert-bar" role="region" aria-label="Crisis support">
      <Container>
        <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap position-relative">
          <span className="mm-alert-bar__text text-center">
            Going through a crisis? You&rsquo;re not alone &mdash; help is available
            right now.
          </span>

          <Button
            as={Link}
            to="/crisis"
            className="mm-alert-bar__cta btn-sm"
            aria-label="Get crisis help now"
          >
            Get help now
          </Button>

          <button
            type="button"
            className="mm-alert-bar__close position-absolute end-0"
            aria-label="Dismiss crisis notice"
            onClick={() => setVisible(false)}
          >
            <FiX size={16} aria-hidden="true" />
          </button>
        </div>
      </Container>
    </div>
  );
}
